import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { PadContainer } from 'smartsuite-ui/lib/containers/PadContainer';
import { ButtonWithIcon } from 'smartsuite-ui/lib/forms/ButtonWithIcon';
import { icons } from 'smartsuite-ui/lib/constants/icons';
import { useLabelContext } from '../../shared/hooks/labelContext';

const titleWidthPad = 4;

export default function SelectorContainer(props) {
    const { dashboardLabels } = useLabelContext();
    const [isHovered, setIsHovered] = useState(false);

    // eslint-disable-next-line complexity
    function getContainerClass() {
        const baseClass = 'selector-container';
        if (props.isSelectable && props.isActive) {
            return `${baseClass} ${baseClass}--active`;
        }
        if (props.isSelectable && isHovered) {
            return `${baseClass} ${baseClass}--hover`;
        }
        return baseClass;
    }

    function renderRemove() {
        if (!props.isActive) {
            return <PadContainer />;
        }

        return (
            <>
                <PadContainer cssClassModifiers={['pad-small']} />
                <ButtonWithIcon
                    iconClass={icons.x}
                    title={dashboardLabels.unpublishFilter}
                    onClick={(event) => {
                        props.onSelectorRemoveClick();
                        event.stopPropagation();
                    }}
                />
            </>
        );
    }

    // eslint-disable-next-line complexity
    function renderTitle() {
        const baseClass = 'selector-container__title';
        const linkClass =
            props.isSelectable && !props.isActive ? `${baseClass}--link` : '';
        const hoveredClass =
            isHovered && !props.isActive ? `${baseClass}--hover` : '';
        return (
            <span
                className={`${baseClass} ${linkClass} ${hoveredClass}`}
                style={{
                    width: props.titleWidth
                        ? `${props.titleWidth + titleWidthPad}px`
                        : 'auto',
                    whiteSpace: 'break-spaces',
                    wordBreak: 'break-word',
                }}
            >
                {props.title}
            </span>
        );
    }

    function onClick() {
        if (!props.isSelectable) {
            return;
        }

        props.onSelectorClick();
    }

    return (
        <div
            className={getContainerClass()}
            onClick={onClick}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            {renderTitle()}
            {props.children}
            {renderRemove()}
        </div>
    );
}

SelectorContainer.propTypes = {
    children: PropTypes.node.isRequired,
    isActive: PropTypes.bool.isRequired,
    isSelectable: PropTypes.bool.isRequired,
    onSelectorClick: PropTypes.func.isRequired,
    onSelectorRemoveClick: PropTypes.func.isRequired,
    title: PropTypes.string,
    titleWidth: PropTypes.number,
};
